

// Helper function to check if the language is supported
export const isValidLanguage = (language) => {
  const supportedLanguages = ["NL", "FR", "DE", "EN"];
  return supportedLanguages.includes(language);
};

// Language code mapping function
export const languageCodeMapper = (langCode) => {
  if (!langCode) {
      // If langCode is null or an empty string, return null
      return null;
  }

  let languageCodeArray = langCode.split("-");
  let language = languageCodeArray[0].toUpperCase();

  // Use the helper function to check if the language is valid
  if (isValidLanguage(language)) {
      return language;
  }

  // Return EN as default if language is not valid
  return "EN";
};

  